import * as t from './actionTypes';
import * as api from './api';

export function register(data, successCB, errorCB) {
    return (dispatch) => {
        api.createUserWithEmailAndPassword(data, function (success, user, error) {
            if (success) {
                dispatch({type: t.LOGIN_SUCCESS, user: user});
                successCB();
            } else if (error) errorCB(error)
        });
    };
}

export function login(data, successCB, errorCB) {
    return (dispatch) => {
        api.signInWithEmailAndPassword(data, function (success, data, error) {
            if (success) {
                dispatch({type: t.LOGIN_SUCCESS, user: data});
                successCB(data);
            }else if (error) errorCB(error)
        });
    };
}

export function logout(successCB, errorCB) {
    return (dispatch) => {
        api.signOut(function (success, data, error) {
            if (success) {
                dispatch({type: t.LOGGED_OUT});
                successCB();
            }else if (error) errorCB(error)
        });
    };
}
